var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.491 14.9226L35.4816 14.8851L30.2222 1.52103C29.9879 0.766345 29.2894 0.246033 28.4972 0.246033H7.17848C6.3816 0.246033 5.67379 0.77572 5.44879 1.53978L0.531601 14.7679L0.517539 14.8007L0.508164 14.8382C0.447226 15.0679 0.428476 15.3023 0.461289 15.532C0.456601 15.607 0.451914 15.682 0.451914 15.757V32.9085C0.453154 33.664 0.753818 34.3882 1.28803 34.9224C1.82224 35.4566 2.54643 35.7573 3.30191 35.7585H32.7019C34.2722 35.7585 35.5519 34.4788 35.5566 32.9085V15.757C35.5566 15.696 35.5566 15.6351 35.5519 15.5835C35.5707 15.3538 35.5519 15.1335 35.491 14.9226ZM21.6254 12.907L21.6113 13.6429C21.5738 15.7476 20.1207 17.1632 17.9972 17.1632C16.9613 17.1632 16.0707 16.8304 15.4285 16.1976C14.7863 15.5648 14.4347 14.6835 14.416 13.6429L14.4019 12.907H4.75504L8.4816 3.84603H27.1941L31.0238 12.907H21.6254ZM4.04723 16.507H11.4207C12.5597 19.1835 14.9832 20.7632 18.0019 20.7632C19.5816 20.7632 21.0488 20.3226 22.2347 19.4882C23.2754 18.757 24.0863 17.7351 24.6113 16.507H31.9472V32.1585H4.04723V16.507Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import-icon.0989cfccb2fe920cde98fbd8088c4206.svg";
export { ForwardRef as ReactComponent };